import React from "react";
import Page, { Block, Content } from "../../Content";
import styles from "./TextPageLayout.module.scss";

export default function TextPageLayout({breadcrumb, title, children}) {
    
    return (
        <Page className={styles.tp}>
            {
                !!breadcrumb &&
                <Block className={styles.breadcrumb}>{breadcrumb}</Block>
            }
            <Block>
                <Content
                    className={styles.title}
                    noSection
                    stretch
                >
                        <h1 className={styles.title__text}>{title}</h1>
                </Content>
                <Content
                    className={styles.content}
                    noSection
                >
                    {children}
                </Content>
            </Block>
        </Page>
    )
}